module.exports = __webpack_public_path__ + "static/media/featured-video-1.fb239da5.png";